import { create } from "zustand";

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
type ErrorStore = {
  errorMessage: string | null;
  setErrorMessage: (errorMessage: string | null) => void;
};

// TODO: Might want a better mechanism for handling errors globally.
export const errorStore = create<ErrorStore>((set) => ({
  errorMessage: null,
  setErrorMessage(errorMessage) {
    set({ errorMessage });
  },
}));
